export default function Footer() {
  return (
    <footer className="bg-white text-gray-900 py-12 border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-8 mb-8">
          {/* About */}
          <div>
            <div className="flex items-center space-x-2 mb-4">
              <span className="text-xl font-bold">ARC</span>
            </div>
            <p className="text-sm text-gray-600 leading-relaxed">
              Queensland's first dedicated neurotechnology rehabilitation hub, pioneering advanced recovery solutions.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-bold mb-4 text-lg">Quick Links</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="/centre" className="text-gray-600 hover:text-teal-600 transition-colors duration-300 cursor-pointer">The Centre</a></li>
              <li><a href="/neuroplasticity" className="text-gray-600 hover:text-teal-600 transition-colors duration-300 cursor-pointer">Neuroplasticity</a></li>
              <li><a href="/technology" className="text-gray-600 hover:text-teal-600 transition-colors duration-300 cursor-pointer">Technology</a></li>
              <li><a href="/treatment" className="text-gray-600 hover:text-teal-600 transition-colors duration-300 cursor-pointer">Treatment Programs</a></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-bold mb-4 text-lg">Services</h4>
            <ul className="space-y-2 text-sm">
              <li><a href="#" className="text-gray-600 hover:text-teal-600 transition-colors duration-300 cursor-pointer">Robotic Rehabilitation</a></li>
              <li><a href="#" className="text-gray-600 hover:text-teal-600 transition-colors duration-300 cursor-pointer">Virtual Reality Therapy</a></li>
              <li><a href="#" className="text-gray-600 hover:text-teal-600 transition-colors duration-300 cursor-pointer">AI-Powered Programs</a></li>
              <li><a href="#" className="text-gray-600 hover:text-teal-600 transition-colors duration-300 cursor-pointer">Veteran Support</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-bold mb-4 text-lg">Contact</h4>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start space-x-2">
                <i className="ri-map-pin-line text-lg mt-0.5 text-teal-600"></i>
                <span className="text-gray-600">Dickson Rd, Morayfield QLD 4506</span>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-phone-line text-lg text-teal-600"></i>
                <span className="text-gray-600">0410799422</span>
              </li>
              <li className="flex items-center space-x-2">
                <i className="ri-mail-line text-lg text-teal-600"></i>
                <span className="text-gray-600">enquire@archealth.net.au</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-200 pt-8 flex flex-col md:flex-row items-center justify-center text-sm">
          <p className="text-gray-600">
            © 2025 ARC Accelerated Recovery Centre. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
